import trackingTemplateCompaniesModalController from "./trackingTemplateCompaniesModal.controller";

export default /*@ngInject*/ function ($uibModal, AuditTrailEntityDataService, helperService) {

    const vm = this;

    vm.openEditTemplateCompaniesModal = openEditTemplateCompaniesModal;

    async function openEditTemplateCompaniesModal() {
        const editTemplateCompaniesModal = $uibModal.open({
            templateUrl: '/App/Components/TemplateTracking/trackingTemplateCompanies/trackingTemplateCompaniesModal.tmpl.html',
            controller: trackingTemplateCompaniesModalController,
            controllerAs: 'ttcmvm',
            backdrop: 'static',
            resolve: {
                template: () => vm.selectedTemplate,
                productId: () => vm.productId,
                availableCompanies: () => vm.availableCompanies
            },
            size: 'lg'
        });

        try {
            const companiesArray = await editTemplateCompaniesModal.result;
            updateCompanies(companiesArray);
        } catch (err) {
            return;
        }
    }

    async function updateCompanies(companiesArray) {
        let postData = {
            TableId: vm.selectedTemplate.Id,
            CompanyIds: companiesArray,
            ProductId: vm.productId
        }

        await AuditTrailEntityDataService.createTableCompanyTrackingEntry(postData);
    }  
}
